import React, { useState, useRef } from "react";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import "./Uploader.css";
import logo from "../../../assets/Nexum-Marchio.png";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';


const FileUploader: React.FC<{
  onFileUpload: (file: File) => void;
  onClose: () => void;
}> = ({ onFileUpload, onClose }) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [isValid, setIsValid] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsValid(true);
    const files = event.target.files;
    if (files && files.length > 0) {
      setSelectedFile(files[0]);
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  };
  const handleRemoveFile = () => {
    setSelectedFile(null);
    setIsValid(false);
    setErrorMessage("");
    // Reimposta il valore dell'input file
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };
  

  const handleUpload = () => {
    if (selectedFile && isValid) {
      onFileUpload(selectedFile);
      setSelectedFile(null);
      setIsValid(false);
    } else {
      setErrorMessage("Please select a file before saving.");
    }
  };

  const handleClickUploadButton = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <div className="modalUploader">
      <div className="modal-content-Uploader">
        <div className="headerUploader">
          <img src={logo} className="uploaderLogo" alt={"nexumLogo"} />
         
        </div>
        {selectedFile ? (
          <div><CheckCircleIcon  style={{
            marginLeft: "8px",
            color: "green",
            marginBottom: "-5px",
          }} />
            <span>{selectedFile.name}</span>
            <HighlightOffIcon
              onClick={handleRemoveFile}
              style={{
                cursor: "pointer",
                marginLeft: "1em",
                color: "red",
                marginBottom: "-5px",
              }}
            />
          </div>
        ) : (
          <div className="ButtonContainer">
            <CloudUploadIcon fontSize="large" className="UploadIcon" onClick={handleClickUploadButton}/>
            <h3>Upload your file here</h3>
          </div>
          
        )}
        {/* Input file nascosto */}
        <input
          type="file"
          ref={fileInputRef}
          onChange={handleFileChange}
          style={{ display: "none" }}
        />
        {/* Mostra il messaggio di errore solo se non è valido */}
        <br />
        {!isValid && <span style={{color:'red'}}>{errorMessage}</span>}
        <div className="buttonUploader">
          <button className="buttonSave" onClick={handleUpload}>
            Upload
          </button>
          <button className="buttonDelete" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default FileUploader;
